import { render, staticRenderFns } from "./AddProductReturn.vue?vue&type=template&id=147e52cd&scoped=true&"
import script from "./AddProductReturn.vue?vue&type=script&lang=js&"
export * from "./AddProductReturn.vue?vue&type=script&lang=js&"
import style0 from "./AddProductReturn.vue?vue&type=style&index=0&id=147e52cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147e52cd",
  null
  
)

export default component.exports